import React from 'react';

const DisclaimerBanner = () => {
  return (
    <div className="disclaimer-banner">
      <strong>⚠️ Important Disclaimer:</strong> The content on this blog is based on my personal experience as a mother. It is for informational purposes only and is NOT a substitute for professional medical advice, diagnosis, or treatment. Always consult with your pediatrician, doctor, or other qualified healthcare provider for any questions you have regarding your child's health or development.
    </div>
  );
};

export default DisclaimerBanner;
